import { render, staticRenderFns } from "./optionalFund.vue?vue&type=template&id=45c96b6e"
import script from "./optionalFund.vue?vue&type=script&lang=js"
export * from "./optionalFund.vue?vue&type=script&lang=js"
import style0 from "./optionalFund.vue?vue&type=style&index=0&id=45c96b6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports